import React from 'react'
import './SpecialSessions.css'
import sampleproposal from '../../assets/docs/sampleproposal.docx'
// import CMIA from '../../assets/docs/Contemporary Innovation in Artificial Intelligence.pdf'

//import SS06 from '../../assets/docs/SS06_Ethical and Responsible Use of AI Technologies in Healthcare, Educational, Financial and Agricultural Industries_BNMIT_Dr. Sumathi_alliance - Conference Special Session.pdf'
//import SS07 from '../../assets/docs/SS07_Dr SSS -PowerEngineering_ Special Session ICIITCEE_2025.pdf'
//import SS08 from '../../assets/docs/SS08_Intelligent Tech for PE Converters _EV chargin systems_Special_Session_ICIITCEE_2025__SRK KV.pdf'
//import ss09 from '../../assets/docs/SS09_Innovations in SignalProcessing_Adv Communications_ Dr.Rohit_Delhi_Proposal_for_SPECIAL_SESSION_in_ICITCEE_2025.pdf'
//import ss10 from '../../assets/docs/Special session 10 - session-call-for-MML-2025.pdf'
//import SS11 from '../../assets/docs/SS11_IIHMR_Bangalore_Proposal_DH_session_BNMIT.pdf'
//import SS12 from '../../assets/docs/SS12_AI in Healthcare and Biomedical Applications_IITCEE-2025.pdf'
//import SS13 from '../../assets/docs/SS13__Advancements in Internet of Things-Bridging Technology and Real-World Applications_Presidency college.pdf'

const SpecialSessions = () => {
    return (
        <div className='SpecialSessions'>
            <h1 className="ch">Proposed Special Sessions</h1>
            <div className="para">
              <div className="marquee">
 <h1 className="heading-blink" style={{ fontSize: "20px", marginLeft: "350px", lineHeight: "1.2" }}>
  <b>Call For Special Sessions Proposals</b>
    –<span className="status">Will be announced soon</span>
</h1>
</div>
               {/*}
                <p align="justify" style={{ textTransform: "none" }}><i className="fa-solid fa-hand-point-right fa-lg"></i> ICIITCEE
                    2027 will be hosting a series of special sessions.
                    Each organized session will be with a minimum of FIVE or more papers that will
                    be subject to regular review cycle by the session organizer.
                    All submissions should be done through cmt tool.
                </p>


                <p align="justify" style={{ textTransform: "none" }}><i className="fa-solid fa-hand-point-right fa-lg"></i>
                    Non-presenting papers will not appear on the proceedings of the conference.
                    All accepted and presented papers will be submitted for possible inclusion in IEEE XPLORE digital
                    library.
                </p>
                 <p align="justify" style={{ textTransform: "none" }}><i className="fa-solid fa-hand-point-right fa-lg"></i>
                    A Special Session may be proposed by a group of no more than two people, and each team may propose only one Special Session.
                </p>


                {/* <p align="justify" style={{ textTransform: "none" }}><i className="fa-solid fa-hand-point-right fa-lg"></i>
                    Format to submit the Special session:</p>
                <p style={{ textTransform: "none" }}> Submit the special session proposals in the following format to:
                    <span style={{ textTransform: "none" }}><a
                        href="mailto:iitcee.bnmit@gmail.com">iitcee.bnmit@gmail.com</a></span>
                </p>
                <ul style={{ padding: "2rem" }}>
                    <li style={{ textTransform: "none" }}>&mdash;&nbsp;&nbsp;Title of the Special Session</li>
                    <li style={{ textTransform: "none" }}>&mdash;&nbsp;&nbsp;Objective of the Special Session</li>
                    <li style={{ textTransform: "none" }}>&mdash;&nbsp;&nbsp;Topics of the Special Session</li>
                    <li style={{ textTransform: "none" }}>&mdash;&nbsp;&nbsp;Name and Affiliation of the proposer (Chair)</li>
                </ul>
                <a href={sampleproposal} download="sampleproposal.docx" className="smalltite"><button
                    className="download-btn">Download proposal format</button></a>
                <p><b>*CALL FOR SPECIAL SESSION PROPOSAL IS CLOSED*</b></p> */}


                
                       {/*<p align="justify" style={{ textTransform: "none" }}><i className="fa-solid fa-hand-point-right fa-lg"></i>
                    Special Session Proposal Template:
                    <a href= {template} rel="noreferrer" target="_blank" download="Proposal _Special Session_IITCEE2026.docx"
                                            className="smalltite"><button className="download-btn">Download here</button></a>

                </p>
                <p>
  <i className="fa-solid fa-hand-point-right fa-lg"></i>
  Note: Mail the Special Session Proposal to: 
  <span style={{ backgroundColor: '#a3e9e4ff', color: 'black' }}>
    <a href= "mailto:iitcee2026.bnmit@gmail.com">
      iitcee2026.bnmit@gmail.com
    </a>
  </span>
</p>   */}

            </div>
           <div className="kele">
              {/*  <table border="4" style={{ textTransform: "none" }}>
                    <thead>
                        <tr>
                            <th style={{ backgroundColor: "#333a38", color: "white", textAlign: "center", border: "2px solid white" }}>Special Session ID </th>
                            <th style={{ backgroundColor: "#333a38", color: "white", textAlign: "center", border: "2px solid white" }}>Title/Organizers</th>
                            <th style={{ backgroundColor: "#333a38", color: "white", textAlign: "center", border: "2px solid white" }}>Brochure</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr style={{ height: "220px" }}>
                            <td>SS01</td>
<td style={{ textAlign: "justify" }}>
  <p className="td-main" style={{ textTransform: "none" }}>
    Smart Innovations: Evolving Intelligent Systems and Next-Gen Electronic Technologies
  </p>
  <p className="td-main" style={{ textTransform: "none", fontSize: "16px" }}>
    Session Organizers:
  </p>
  <ul style={{ paddingLeft: "1em", margin: "0", listStyleType: "disc" }}>
  <li style={{ textTransform: "none" }}>
    Dr. Sangeetha V, Associate Professor, Department of Computer Science and Engineering, Ramaiah Institute of Technology, Bangalore 560054, Karnataka, India  
    <a href="mailto:drsangeethav@msrit.edu">drsangeethav@msrit.edu</a>
  </li>
  <li style={{ textTransform: "none" }}>
    Dr. Vaneeta M, Associate Professor, Department of Artificial Intelligence & Data Science, Ramaiah Institute of Technology, Bangalore 560054, Karnataka, India  
    <a href="mailto:vaneetam@msrit.edu">vaneetam@msrit.edu</a>
  </li>
</ul>
</td>

                            <td><a href={SS01}
                                download="SS01" className="smalltite">
                                Download session info</a>
                            </td>
                        </tr>

                        <tr style={{ height: "220px" }}>
                            <td>SS02</td>
                           <td style={{ textAlign: "justify" }}>
  <p className="td-main" style={{ textTransform: "none" }}>
    Harnessing AI and Machine Learning for Smart Solutions in Electrical, Electronics, and Computer Engineering
  </p>
  <p className="td-main" style={{ textTransform: "none", fontSize: "16px" }}>
    Session Organizers:
  </p>
  <ul style={{ margin: 0, paddingLeft: "1em", listStyleType: "disc" }}>
    <li style={{ textTransform: "none" }}>
      Dr. Parul Verma, Associate Professor, Amity Institute of Information Technology,  
      Amity University Uttar Pradesh, Lucknow
    </li>
    <li style={{ textTransform: "none" }}>
      Dr. Ranjana Rajnish, Associate Professor, Amity Institute of Information Technology,  
      Amity University Uttar Pradesh, Lucknow
    </li>
    <li style={{ textTransform: "none" }}>
      Dr. Shahnaz Fatima, Associate Professor, Amity Institute of Information Technology,  
      Amity University Uttar Pradesh, Lucknow
    </li>
  </ul>
</td>

                            <td> <a href={SS02}

                                download="SS02"
                                className="smalltite">Download session info</a></td>
                        </tr>

                        <tr style={{ height: "220px" }}>
                            <td>SS03</td>
                            <td style={{ textAlign: "justify" }}>
  <p className="td-main" style={{ textTransform: "none" }}>
    Recent Trends in AI based Intelligent Data Analytics
  </p>
  <p className="td-main" style={{ textTransform: "none", fontSize: "16px" }}>
    Session Organizers:
  </p>
  <ul style={{ margin: 0, paddingLeft: "1em", listStyleType: "disc" }}>
    <li style={{ textTransform: "none" }}>
      Dr. B. Karthik, Professor & Dean Publications,  
      ECE, Bharath Institute of Higher Education and Research
    </li>
  </ul>
</td>

                            <td> <a href={SS03}
                                download="SS03"
                                className="smalltite">Download session info</a>
                            </td>
                        </tr>

                        <tr style={{ height: "220px" }}>
                            <td>SS04</td>
                            <td style={{ textAlign: "justify" }}>
                                <p style={{ textTransform: "none" }} className="td-main">
                                    Emerging Trends and Challenges in Machine Learning and Deep Learning
                                </p>
                                <p style={{ textTransform: "none", fontSize: "16px" }} className="td-main">
                                    Session Organizers:
                                </p>
                               <li style={{ textTransform: "none" }}>
  Dr.B.Hemalatha, Assistant Professor,ECE
  Bharath Institute of Higher Education and Research
</li>
                               
                            </td>
                            <td> <a href={SS04}

                                download="SS04"
                                className="smalltite">Download session info</a>
                            </td>
                        </tr>

                       <tr>
  <td>SS05</td>
  <td style={{ textAlign: "justify" }}>
    <p className="td-main" style={{ textTransform: "none" }}>
     Next-Gen AI: Agentic Models, Neuro-Symbolic Systems, and Responsible AI for Industry and Society
    </p>
    <p className="td-main" style={{ textTransform: "none", fontSize: "16px" }}>
      Session Organizers:
    </p>
    <ul style={{ margin: 0, paddingLeft: "1em", listStyleType: "disc" }}>
      <li style={{ textTransform: "none" }}>
        Dr. Sumathi D, Associate Professor, Computer Science and Engineering,  
        CMR Institute of Technology, Bangalore - 560037
      </li>
      <li style={{ textTransform: "none" }}>
        Prof. Manjunatha Babu B, Senior Assistant Professor, Artificial Intelligence and Data Science,  
       CMR Institute of Technology, Bangalore - 560037
      </li>
    </ul>
  </td>
  <td>
    <a href={SS05}
       download="SS05"
       className="smalltite">
       Download session info
    </a>
  </td>
</tr>
  <tr>
  <td>SS06</td>
  <td style={{ textAlign: "justify" }}>
    <p className="td-main" style={{ textTransform: "none" }}>
     Decentralized Energy Systems: AI, Blockchain and Digital Twin Synergies for Smart Grids.
    </p>
    <p className="td-main" style={{ textTransform: "none", fontSize: "16px" }}>
      Session Organizers:
    </p>
    <ul style={{ margin: 0, paddingLeft: "1em", listStyleType: "disc" }}>
      <li style={{ textTransform: "none" }}>
        Dr. Pushpendra Singh (SM-IEEE, SM-IIIE, Fellow-IEI) Program Director and Professor Energy Sciences
        Atria University Bengaluru (India)
      </li>
      <li style={{ textTransform: "none" }}>
        Dr. Prashant Kumar (SM-IEEE, LM-IEI) Associate Professor - EEE
       COER University Roorkee (India)
      </li>
    </ul>
  </td>
  <td>
    <a href={SS06}
       download="SS06"
       className="smalltite">
       Download session info
    </a>
  </td>
</tr>
<tr>
  <td>SS07</td>
  <td style={{ textAlign: "justify" }}>
    <p className="td-main" style={{ textTransform: "none" }}>
     Synergy of VLSI and AI: From Smart Chips to Intelligent Systems.
    </p>
    <p className="td-main" style={{ textTransform: "none", fontSize: "16px" }}>
      Session Organizers:
    </p>
    <ul style={{ margin: 0, paddingLeft: "1em", listStyleType: "disc" }}>
      <li style={{ textTransform: "none" }}>
        Dr. Sarfraz Hussain Assistant Professor ECE REVA University, Bengaluru
        Secretary, IEEE CAS Bangalore Chapter
      </li>
      <li style={{ textTransform: "none" }}>
        Mr. Aloke Das Founder & Director ECE
        Lab & Lectures, Bengaluru Chair, IEEE CAS Bangalore Chapter

      </li>
    </ul>
  </td>
  <td>
    <a href={SS07}
       download="SS07"
       className="smalltite">
       Download session info
    </a>
  </td>
</tr>
<tr>
  <td>SS08</td>
  <td style={{ textAlign: "justify" }}>
    <p className="td-main" style={{ textTransform: "none" }}>
     Emerging Trends in Electric Vehicle Energy Systems.
    </p>
    <p className="td-main" style={{ textTransform: "none", fontSize: "16px" }}>
      Session Organizers:
    </p>
    <ul style={{ margin: 0, paddingLeft: "1em", listStyleType: "disc" }}>
      <li style={{ textTransform: "none" }}>
       Dr. Shubha Rao K Associate Professor EEE
       BNM Institute of Technology
      </li>
      <li style={{ textTransform: "none" }}>
        Dr. Madhu S Associate Professor EEE
        BNM Institute of Technology
      </li>
    </ul>
  </td>
  <td>
    <a href={SS08}
       download="SS08"
       className="smalltite">
       Download session info
    </a>
  </td>
</tr>



                      


                    </tbody>
                </table>*/}
            </div>

        </div>
    )
}

export default SpecialSessions